export async function playVideoSafely(video, onError) {
  if (!video) return false;
  try {
    await video.play();
    return true;
  } catch (error) {
    // A pause, seek, source replacement or unmount can cancel a pending play.
    if (error.name !== 'AbortError') onError?.(error);
    return false;
  }
}
